module.exports = __webpack_public_path__ + "img/27.653e5540.jpg";